<div class="flex items-center justify-center h-[100%]">
    @if (profile) {
        <button
            class="profile-trigger si-header-item btn btn-circle btn-ghost"
            [attr.aria-label]="'header-actions-label-profile' | translate"
            [siHeaderDropdownTriggerFor]="profileDropdown"
            (openChange)="isDropdownOpen = $event"
        >
            <si-avatar [initials]="profile.initials" [altText]="profile.displayName" [imageUrl]="userPhotoUrl()" />
        </button>
        <ng-template #profileDropdown>
            <si-header-dropdown>
                @if (mode === profileTypes.TEXT || mode === profileTypes.FULL) {
                    <app-header-profile-selector (menuClose)="closeDropdown()"></app-header-profile-selector>
                }
            </si-header-dropdown>
        </ng-template>
    }
</div>
